<micro-select-combo #sel
              placeholder="Secure Access Token Source Type"
              [mode]="mode"
              [(id)]="saTokenSourceType"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
